import { Phone, EnvelopeSimple, MapPin, InstagramLogo, TwitterLogo, LinkedinLogo, WhatsappLogo } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { scrollTo } from "@/components/site/Header";
import { SERVICES, buildWhatsAppLink } from "@/data/services";

export const Footer = () => {
  return (
    <footer className="relative bg-rescue-surface border-t border-white/10">
      {/* CTA band */}
      <div className="border-b border-white/10">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <h2 className="font-display uppercase tracking-tighter text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.85]">
            Stuck right now?
          </h2>
          <div className="flex flex-wrap gap-4">
            <button
              data-testid="footer-request-btn"
              onClick={() => scrollTo("request")}
              className="bg-rescue-primary hover:brightness-110 active:scale-95 transition-all text-white text-base font-semibold px-7 py-4 rounded-sm uppercase tracking-wide"
            >
              Request Help Now
            </button>
            <a
              href="tel:+919892648175"
              data-testid="footer-call-btn"
              className="inline-flex items-center gap-2 border border-white/20 hover:bg-white/10 active:scale-95 transition-all text-white text-base font-semibold px-7 py-4 rounded-sm uppercase tracking-wide"
            >
              <Phone weight="fill" size={18} /> Call +91 98926 48175
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="grid place-items-center h-8 w-8 bg-rescue-primary text-white font-display text-xl leading-none">
              R
            </span>
            <span className="font-display text-2xl uppercase tracking-tight leading-none text-white">
              Rapid<span className="text-rescue-primary">Rescue</span>
            </span>
          </div>
          <p className="text-white/55 text-sm leading-relaxed mt-4 max-w-xs">
            24×7 roadside assistance and instant vehicle insurance. Any vehicle, any road, any hour.
          </p>
          <div className="flex gap-3 mt-6">
            {[InstagramLogo, TwitterLogo, LinkedinLogo].map((Ic, i) => (
              <a
                key={i}
                href="#"
                data-testid={`footer-social-${i}`}
                className="grid place-items-center h-10 w-10 border border-white/15 rounded-sm text-white/70 hover:text-white hover:border-rescue-primary transition-colors"
              >
                <Ic size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white/40 text-xs uppercase tracking-widest font-semibold">Services</h4>
          <ul className="mt-4 space-y-3">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <button
                  onClick={() => scrollTo("services")}
                  className="text-white/70 hover:text-white text-sm transition-colors"
                >
                  {s.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white/40 text-xs uppercase tracking-widest font-semibold">Company</h4>
          <ul className="mt-4 space-y-3">
            <li><button onClick={() => scrollTo("how")} className="text-white/70 hover:text-white text-sm">How it works</button></li>
            <li><button onClick={() => scrollTo("insurance")} className="text-white/70 hover:text-white text-sm">Insurance</button></li>
            <li><button onClick={() => scrollTo("coverage")} className="text-white/70 hover:text-white text-sm">Coverage</button></li>
            <li><Link to="/admin" data-testid="footer-admin-link" className="text-white/70 hover:text-white text-sm">Admin dashboard</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white/40 text-xs uppercase tracking-widest font-semibold">Reach us</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><Phone size={16} className="text-rescue-primary" /> +91 98926 48175</li>
            <li>
              <a
                href={buildWhatsAppLink("Hi RapidRescue, I need roadside help.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-2 hover:text-white transition-colors"
              >
                <WhatsappLogo size={16} className="text-[#25D366]" /> WhatsApp us
              </a>
            </li>
            <li className="flex items-center gap-2"><EnvelopeSimple size={16} className="text-rescue-primary" /> Chalkebhavesh@gmail.com</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="text-rescue-primary mt-0.5" /> Control HQ, 240+ cities across India</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/40 text-xs">
          <span>© {new Date().getFullYear()} RapidRescue. All rights reserved.</span>
          <span className="uppercase tracking-widest">Built for the road · 24×7</span>
        </div>
      </div>
    </footer>
  );
};
